import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
// import TableSegregation from "./tableSegregation";
import TableResults from "./tableProducts";
import Loading from "../../../../../components/Loading";
import moment from "moment";
import "moment/locale/pt-br";
import { getSegregations, getDevolutionProducts } from "../../actions";
import { createLoadingSelector } from "../../../../../store/api/selectors";
import { numberToReal } from "../../../../../helpers/functions";
moment.locale("pt-br");

class TableDevolution extends Component {
  componentDidMount() {
    const { period } = this.props;
    this.props.getSegregations(period);
    this.props.getDevolutionProducts(period, "?pageNumber=1&pageSize=50");
  }

  render() {
    const { products, period, isFetching } = this.props;
    const newProducts =
      products &&
      products.Items &&
      products.Items.map((item) => {
        return {
          ...item,
          DataEmissao: moment(item.DataEmissao).format("L"),
          TotalDesconto: numberToReal(item.TotalDesconto),
          TotalBruto: numberToReal(item.TotalBruto),
          ValorAcrescido: numberToReal(item.ValorAcrescido),
          ValorOutrasDespesas: numberToReal(item.ValorOutrasDespesas),
          TotalFrete: numberToReal(item.TotalFrete),
        };
      });

    return (
      <div style={{ height: "calc(100vh - 210px)" }}>
        {isFetching ? <Loading /> : null}

        {newProducts ? (
          <TableResults
            data={newProducts}
            paging={products.Paging}
            period={period}
            action={this.props.getDevolutionProducts}
          />
        ) : null}
      </div>
    );
  }
}

const loadingSelector = createLoadingSelector([
  "GET_DEVOLUTION_PRODUCTS_SUCCESS",
  "GET_SEGREGATIONS",
  "DOWNLOAD_ANALYTICAL_PRODUCTS",
]);

const mapStateToProps = (state) => ({
  segregations: state.results.segregations,
  products: state.results.productsDevolution,
  isFetching: loadingSelector(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getSegregations,
      getDevolutionProducts,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(TableDevolution);
